<template>
  <div class="p-4">
    <div class="mb-4">
      <p>
        <span v-html="Utils.t('modal.audioPlayer.vocalInstruction', {date: vocalDate(),time: vocalTime()})"></span>, 
        <span>{{$t('global.by')}}</span>
        <strong>{{ getDati.name }}</strong>.
      </p>
    </div>
    <div class="d-flex gap-3 align-items-center">
      <div v-if="!hideControls">
        <b-button 
          ref="playButton"
          @click="play" 
          variant="light" 
          square 
          size="lg"
          :aria-label="isPlaying ? Utils.t('global.play') : Utils.t('global.stop')"
          style="width: 48px; height: 48px; padding: 0;"
          class="bg-gray-100"
        >
            <i ref="playButtonIcon" class="zmdi" :class="[isPlaying ? 'zmdi-stop' : 'zmdi-play']"
            aria-hidden="true" style="font-size: 36px; line-height: 48px;">
          </i>
        </b-button>
      </div>
      <div class="flex-1 bg-gray-50 rounded-lg overflow-hidden">
        <div style="position: relative; left: -2px;">
          <div ref="waveform" style="inset: 1px -2px; position: relative;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import WaveSurfer from 'wavesurfer.js'
import Utils from "@/services/utils";
import moment from "moment";

export default {
  name: 'vocal-modal',
  props: {
    props: {
      urlVocal: String,
      attachmentData: Object,
      eventData: Object,
    }
  },
  data () {
    return {
      hideControls: true,
      isPlaying : false,
      wavesurfer: null,
    }
  },
  mounted () {
    this.wavesurfer = WaveSurfer.create({
      container:this.$refs.waveform,
      waveColor: '#94a3b8',
      progressColor: '#1e293b',
      cursorColor: '#ffc107',
      normalize: true,
      cursorWidth: 2,
      height: 80,
      barWidth: 3,
      barRadius: 3,
    })

    this.wavesurfer.load(this.getUrlVocal);
    this.hideControls=false
    this.wavesurfer.on('play', () => {
      this.isPlaying=true
    })
    this.wavesurfer.on('pause', () => {
      this.isPlaying=false;
    })
    //console.log(this.props.attachmentData)
    /** When the audio finishes playing */
    this.wavesurfer.on('finish', () => {
      this.isPlaying=false;
    })
  },
  computed: {
    Utils() {
      return Utils
    },
    getUrlVocal: function (){
      return this.props.urlVocal
    },
    getDati: function (){
      return this.props.eventData.dati
    },
  },
  methods: {
    vocalDate(){
      return moment(this.props.attachmentData.created_at).local().format(Utils.t('datetime.date'))
    },
    vocalTime(){
      return moment(this.props.attachmentData.created_at).local().format("HH:mm")
    },
    play () {
      if(!this.wavesurfer.isPlaying()){
        this.wavesurfer.play()
      }else{
        this.wavesurfer.pause()
      }
    }
  }
}
</script>